import { forwardRef } from 'react'
import { ChevronDown } from 'lucide-react'
import { inputClasses } from './Input'

const Select = forwardRef(function Select({ className = '', wrapperClassName = '', error, children, ...props }, ref) {
    return (
        <div className={['relative inline-block w-full', wrapperClassName].join(' ')}>
            <select
                ref={ref}
                className={[inputClasses(error), 'appearance-none pr-9 cursor-pointer', className].join(' ')}
                {...props}
            >
                {children}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-current" />
        </div>
    )
})

export default Select
